import axios from 'axios';

const API_URL = process.env.REACT_APP_LEADS_SAVE_API;

export const saveLead = async (formValues) => {
    try {
        const response = await axios.post(
            API_URL,
            {
                name: formValues.name,
                email: formValues.email,
                phoneNumber: formValues.phoneNumber,
                program: formValues.program,
                subProgram: formValues.subProgram,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                timeout: 15000, // important if Firestore is slow
            }
        );

        return response.data;
    } catch (error) {
        if (error.response) {
            throw error.response.data;
        }
        throw { message: 'Server not reachable' };
    }
};
